import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MonoLabel } from './MonoLabel';

interface FieldProps {
  label: string;
  children: ReactNode;
  /** Shown under the control. `tone` colours it: up for success, down for errors. */
  hint?: string;
  hintTone?: 'faint' | 'up' | 'down';
  className?: string;
}

/** Mono label above a control with an optional hint line. */
export function Field({ label, children, hint, hintTone = 'faint', className }: FieldProps) {
  return (
    <label className={cn('flex flex-col gap-2', className)}>
      <MonoLabel tone="mute">{label}</MonoLabel>
      {children}
      {hint && (
        <span className={cn('text-[13px]', { faint: 'text-faint', up: 'text-up', down: 'text-down' }[hintTone])}>
          {hint}
        </span>
      )}
    </label>
  );
}
